import Enum from 'enum';

export default new Enum([
    'CLEAR_STATE', // Clear all state. Should be implement by all reducers

    'ACCEPTED_COOKIES',
    'REJECTED_COOKIES',
    'SET_COOKIE_CONSENT_CATEGORIES',
    'RESULT_CONTACT',
    'RESULT_EDITABLE_CONTACT',
    'RESULT_EXTENSIONS',
    'RESULT_EXTENSION',
    'RESULT_OPERATOR_USERS',
    'RESULT_MOBILE_SUBSCRIPTION',
    'RESULT_EXTENSION_ADD_CALENDAR_EVENT',
    'RESULT_EXTENSION_UPDATE_CALENDAR_EVENT',
    'RESULT_EXTENSION_REMOVE_CALENDAR_EVENT',
    'RESULT_EXTENSION_CALENDAR',
    'RESULT_EXTENSION_SET_OPENINGHOURS',
    'RESULT_EXTENSION_CLEAR_EVENTS',
    'RESULT_FETCH_PRESENCE_NOTIFICATIONS',
    'RESULT_CREATE_PRESENCE_NOTIFICATION',
    'RESULT_DELETE_PRESENCE_NOTIFICATION',
    'RESULT_NEW_PROFILE',
    'RESULT_PROFILES',
    'RESULT_PROFILE',
    'RESULT_PROFILE_CREATE',
    'NOTIFY_NEW_PROFILE_CREATED',
    'REMOVE_NOTIFY_NEW_PROFILE_CREATED',
    'RESULT_REMOVE_PROFILE',
    'SET_PERMISSION_ERROR',
    'SET_VOICEMESSAGE_READ',
    'SET_SHARED_VOICEMESSAGE_READ',
    'REMOVE_PERMISSION_ERROR',
    'RESULT_MAIN_NUMBERS',
    'RESULT_SMSSENDER_NAMES',
    'RESULT_CUSTOMER',
    'RESULT_CUSTOMER_CONTACT_FIELDS',
    'RESULT_NOTIFICATION_SCHEME',
    'RESULT_CONTACT_AVATAR_UPDATE',
    'RESULT_CONTACT_AVATAR_DELETE',
    'RESULT_CONTACTS',
    'RESULT_SOCIAL_INTEGRATION_CONTACTS',
    'RESULT_UPDATED_CONTACT',
    'REMOVE_EXTERNAL_CONTACT',
    'RESULT_NEW_EXTERNAL_CONTACT',
    'RESULT_NUMBER_LOOKUP',
    'RESULT_CALL_RECORDS_FETCHED',
    'RESULT_CALL_RECORD_FOR_SCOPE',
    'RESULT_CALL_RECORD',
    'RESULT_VOICE_MESSAGES',
    'RESULT_VOICE_MESSAGES_ERROR',
    'RESULT_REMOVE_CONTACT',
    'RESULT_EXTENSION_MOBILE_STATUS',
    'RESULT_EXTENSION_MOBILE_SUBSCRIPTION',
    'RESULT_CREATE_CALL_ACTION_PERSONAL_CALL',
    'RESULT_DELETE_CALL_ACTION_PERSONAL_CALL',
    'RESULT_CREATE_CALL_ACTION',
    'RESULT_DELETE_CALL_ACTION',
    'RESULT_GET_VOICEMAIL_ACTIONS',
    'RESULT_CREATE_VOICEMAIL_ACTION',
    'RESULT_DELETE_VOICEMAIL_ACTION',
    'RESULT_CALL_ROUTINGS',
    'RESULT_CALL_ROUTINGS_UPDATED',
    'RESULT_CALL_ROUTINGS_DELETED',
    'RESULT_CALL_ROUTINGS_PREDEFS',
    'RESULT_FAVORITES',
    'RESULT_FAVORITE',
    'REMOVED_FAVORITE',
    'ADD_MISSEDCALL_STATE',
    'CLEAR_MISSEDCALL_STATE',
    'SET_CALL_LIST_FILTER',
    'CLEAR_EXTENSIONS_ACTIVE_CALLS',

    'SEARCH',

    'APP_STATE',
    'APP_LANGUAGE',
    'SPOKEN_LANGUAGE',
    'APP_ALLOWED_VERSION',
    'APP_LOGIN_DATA',
    'APP_LOGIN_DATA_CLEAR',
    'APP_LOG_OUT',
    'APP_EXTERNAL_SIGNIN_DATA',
    'APP_EMBEDDED',
    'LAYOUT_COLUMNS',
    'APP_VISIBLE',
    'APP_FOCUS',
    'REGISTER_TOP_CONNECTION',
    'UNREGISTER_TOP_CONNECTION',
    'CALL_METHOD',
    'CALL_CANVAS_SIZE',
    'AUTOANSWER_IP_PHONE',
    'MAKE_CALLS_ENABLED',
    'SHOW_CALL_DIALOG',
    'SET_CALL_DIALOG_TYPE',
    'HIDE_CALL_DIALOG',
    'TOP_RETRY_TIMEOUT_ID',
    'SIP_RETRY_TIMEOUT_ID',
    'ADD_SNACKBAR',
    'REMOVE_SNACKBAR',
    'SET_AUDIO_INITIATED',

    'ADD_NOTICE',
    'DELETE_NOTICE',

    'NETWORK_CONNECTION_CHANGE',

    'RESULT_CHAT_SESSIONS',
    'RESULT_PUBLIC_CHAT_SESSIONS',
    'RESULT_CHAT_SESSION_IMAGE',
    'RESULT_CHAT_SESSION_IMAGE_DELETED',
    'RESULT_CHAT_SESSION',
    'RESULT_CHAT_CREATE_SESSION',
    'RESULT_CHAT_MESSAGES',
    'RESULT_CHAT_MESSAGE',
    'GET_CHAT_REACTIONS',
    'RESULT_CHAT_REACTION',
    'DELETE_CHAT_REACTION',
    'RESULT_FAILED_CHAT_MESSAGE',
    'RESULT_REMOVE_FAILED_MESSAGE',
    'RESULT_CHAT_POST',
    'RESULT_CHAT_COMMENT',
    'RESULT_CHAT_COMMENTS',
    'RESULT_CHAT_MESSAGE_READ',
    'RESULT_CHAT_SESSION_UNREAD',
    'RESULT_CHAT_MUTE_SESSION',
    'RESULT_CHAT_ARCHIVE_SESSION',
    'RESULT_CHAT_POST',
    'RESULT_CHAT_LEAVE_ROOM',
    'RESULT_CHAT_REMOVE_CHAT_MEMBER',
    'RESULT_CHAT_ADD_CHAT_MEMBER',
    'RESULT_CHAT_POST_LIKE',
    'RESULT_CHAT_DETAILS',
    'RESULT_CHAT_CONTENT',
    'RESULT_CHAT_CONTENT_HISTORY',
    'RESULT_ADD_CHAT_ADMIN',
    'RESULT_REMOVE_CHAT_ADMIN',
    'RESULT_OLDER_CHAT_MESSAGES',
    'RESULT_OPEN_GRAPH_DATA',
    'RESULT_CLIENT_REGISTER',
    'RESULT_SESSION',
    'RESULT_TYPING',
    'CHAT_PREVIEW_IMAGE',
    'TEMPORARY_PASSWORD_STATUS',
    'ADD_QUOTED_MESSAGE',
    'REMOVE_QUOTED_MESSAGE',
    'RESULT_CONFERENCE',
    'RESULT_QUEUES',
    'RESULT_QUEUE',
    'RESULT_QUEUE_PROFILE',
    'RESULT_QUEUE_PROFILE_UPDATE',
    'CLEAR_QUEUE_CALL_RECORDS',
    'CLEAR_QUEUE_CALL_RECORDS_BPART_SPECIFIC',
    'RESULT_QUEUE_CALENDAR',
    'RESULT_QUEUE_MEMBER_UPDATE',
    'RESULT_ADD_QUEUE_MEMBERS',
    'RESULT_REMOVE_QUEUE_MEMBERS',
    'RESULT_ADD_QUEUE_WAVE_MAPPINGS',
    'RESULT_REMOVE_QUEUE_WAVE_MAPPING',
    'RESULT_QUEUE_OPENING_HOURS',
    'RESULT_QUEUE_ADD_CALENDAR_EVENT',
    'RESULT_QUEUE_UPDATE_CALENDAR_EVENT',
    'RESULT_QUEUE_REMOVE_CALENDAR_EVENT',
    'RESULT_QUEUE_STAT_SUMMARY',
    'RESULT_ALLOWED_QUEUE_MEMBERS',
    'RESULT_REFER',
    'RESULT_REFER_PROFILE',
    'RESULT_REFER_CALENDAR',
    'RESULT_REFER_OPENING_HOURS',
    'RESULT_REFER_ADD_CALENDAR_EVENT',
    'RESULT_REFER_UPDATE_CALENDAR_EVENT',
    'RESULT_REFER_REMOVE_CALENDAR_EVENT',
    'RESULT_REFER_PROFILES',
    'RESULT_REFERS',
    'RESULT_SHARED_VOICEMAIL',
    'RESULT_SHARED_VOICEMAILS',
    'RESULT_SHARED_VOICEMESSAGE_DELETE',
    'RESULT_SHARED_VOICEMESSAGES_DELETE_ALL',
    'RESULT_VOICEMAILS_DELETE_ALL',
    'RESULT_PARK_CALL',
    'FINISH_UNPARKING',
    'RESULT_USER_SOUNDS',
    'RESULT_REMOVE_SOUND',
    'RESULT_EDIT_SOUND',
    'RESULT_DEFAULT_SOUNDS',
    'RESULT_CREATE_NEW_SOUND',
    'RESULT_CONFERENCES',
    'RESULT_SHARED_EXTENSION',
    'RESULT_WIDGET_CHANNEL',
    'RESULT_WIDGET_CHANNELS',
    'RESULT_CHANNEL_MEMBERS',
    'RESULT_CHANNEL_STAT_SUMMARY',
    'RESULT_CHANNEL_SESSION',
    'RESULT_CHANNEL_SESSION_BADGE_COUNT',
    'RESULT_CHANNEL_CALENDAR',
    'RESULT_CHANNEL_OPENING_HOURS',
    'RESULT_CHANNEL_ADD_CALENDAR_EVENT',
    'RESULT_CHANNEL_UPDATE_CALENDAR_EVENT',
    'RESULT_CHANNEL_REMOVE_CALENDAR_EVENT',
    'RESULT_PAGINATED_ARCHIVED_CHANNEL_SESSIONS',
    'RESULT_CHANNEL_ACTIVE_PROFILE',
    'RESULT_CHANNEL_UPDATED_PROFILE',
    'RESULT_CHANNEL_UPDATED_PROFILES',
    'RESULT_UPDATE_CHANNEL_MEMBER',
    'CHANNEL_COMPOSER_UPDATE',
    'RESULT_WIDGET_MESSAGES',
    'RESULT_WIDGET_MESSAGE',
    'RESULT_OLDER_WIDGET_MESSAGES',
    'RESULT_WIDGET_MESSAGE_READ',
    'RESULT_ARCHIVE_CHANNEL_SESSION',
    'RESULT_UNARCHIVE_CHANNEL_SESSION',

    'RESULT_VOICEMAIL_SETTINGS',
    'RESULT_VOICEMAIL_SETTINGS_UNAVAILABLE',

    'RESULT_REFERAL_ENTRIES',

    'RESULT_SOCIAL_INTEGRATION_SETTINGS',
    'RESULT_SOCIAL_INTEGRATION_AUTH_IN_PROGRESS',
    'RESULT_SOCIAL_INTEGRATION_ERROR',
    'RESULT_INTEGRATION_ACCESS_TOKENS',
    'RESULT_INTEGRATION_ACCESS_DOMAINS',
    'RESULT_CREATE_INTEGRATION_ACCESS_TOKEN',
    'RESULT_REVOKE_TOKEN',
    'RESULT_UPDATE_ACCESS_TOKEN',
    'CLEAR_CREATED_ACCESS_TOKEN',
    'RESULT_SOCIAL_INTEGRATION_EXTERNAL_SYNC',

    'RESULT_SOCIAL_INTEGRATION_CLOUD_FILES',
    'RESULT_SOCIAL_INTEGRATION_CLOUD_FILES_STATUS',
    'RESULT_SOCIAL_INTEGRATION_CLOUD_FILES_CLEAR',

    'COMPOSER_UPDATE', // The user is composing a chat message
    'ATTACHMENT_UPDATE', // The user is composing a chat attachment
    'UPDATE_VOICEMESSAGES_AFTER_DELETE',
    'RESULT_QUEUE_CALL_RECORDS_UNHANDLED_WIDGET',

    'RESULT_TOP_EXTENSION', // When a Top extension is received
    'RESULT_TOP_NEW_MEX_CHANNEL', // When a new MEX (in/out) channel is received
    'RESULT_TOP_NEW_CHANNEL', // When a new channel is received
    'RESULT_TOP_HANGUP_CHANNEL', // When a Hangup is received
    'RESULT_ACTIVE_OMNI_ERRANDS',
    'RESULT_TOP_SYNC_START',
    'RESULT_TOP_SYNC_STOP',
    'RESULT_TOP_WAITING_QUEUE_ITEMS_ADD',
    'RESET_NUMBER_OF_UNREAD_MESSAGES',
    'SET_LOGGED_IN_USER_HAS_CTI_INTEGRATION_FEATURE',
    'SET_LOGGED_IN_USER_HAS_SUPERVISOR_FEATURE',
    'SET_LOGGED_IN_USER_HAS_OMNICHANNEL_FEATURE',
    'SET_LOGGED_IN_USER_HAS_RETURN_BLIND_TRANSFER_FEATURE',
    'SET_LOGGED_IN_USER_HAS_ZENDESK_CALL_LOGGING_APP',
    'SET_USER_OWNED_OMNICHANNEL_ERRANDS_AWAITING_ACTIVITY_COUNT',
    'SET_OMNICHANNEL_IFRAME_REF',
    'SET_OMNI_TICKET_KEY_QUEUE_CALL',
    'SET_TICKET_KEY_FOR_LOCUTUS_SESSION',
    'SET_PBX_PAGE_MOUNTED',
    'SET_PBX_PAGE_UNMOUNTED',
    'SET_PBX_SECTION_MOUNTED',
    'SET_MISSED_CALLS_WIDGET_IS_MOUNTED',
    'SET_MOUNTED_CHAT_SESSION',
    'RESULT_TOP_WAITING_QUEUE_ITEM_ADD',
    'RESULT_TOP_WAITING_QUEUE_ITEM_REMOVE',
    'UPDATE_TOP_CHANNEL',
    'SET_TOP_QUEUE_CALL',
    'SET_QUEUE_CALL_FOR_CHANNEL',
    'CLEAR_TOP_QUEUE_CALLS',
    'UPDATE_WAITING_QUEUE_CALL_ORDER',
    'EXTRACT_CALL_RECORDS_FOR_NUMBER',
    'SET_CENTION_DEEPLINK_FOR_CALLER_ID',
    'REMOVE_CENTION_DEEPLINK_FOR_CALLER_ID',
    'SET_PAI_HEADER',
    'REMOVE_PAI_HEADER',

    'RESULT_PBX_LICENSE',
    'RESULT_LICENSE_DESCRIPTION',

    'RESULT_WALLBOARDS',
    'RESULT_WALLBOARD_CREATED',
    'RESULT_WALLBOARD_UPDATED',
    'RESULT_WALLBOARD_REGENERATED',
    'RESULT_WALLBOARD_DELETED',
    'SET_WALLBOARD_ACCESS',

    'RESULT_OPERATOR_OPERATORS',
    'RESULT_OPERATOR_DATA',

    'EXTENSION_UPDATE_ACTIVE_CALL',
    'EXTENSION_UPDATE_ACTIVE_CALL_PARK_DTO',
    'EXTENSION_UPDATE_ACTIVE_CALL_BAG_VARIABLE',
    'EXTENSION_REMOVE_ACTIVE_CALL',
    'EXTENSION_UPDATE_ACTIVE_PROFILE',
    'EXTENSION_COLISTENING_ADD_LISTENER',
    'EXTENSION_COLISTENING_REMOVE_LISTENER',
    'EXTENSION_SET_EXTERNAL_CHANNEL',
    'EXTENSION_REMOVE_EXTERNAL_CHANNEL',
    'EXTENSION_CALL_MERGED_INTO_CONFERENCE',
    'EXTENSION_UPDATE_ACTIVE_CALL_PIN_CODE',
    'RESULT_EXTENSIONS_NEXT_SCHEDULED_PROFILES',

    'APP_VIDEO_ENABLED',
    'APP_COMPANION_ENABLED',
    'APP_HANDOVER_TO_DESKTOP',
    'APP_USE_AS_COMPANION',
    'APP_COMPANION_DEVICE_NAME',
    'APP_COMPANION_ROLE_LOST',
    'RESULT_COMPANION_DEVICES',
    'APP_COMPANION_LOCATION_STATUS',
    'APP_COMPANION_LOCATION_REPORT',
    'APP_COMPANION_RESPONSIVE',
    'APP_COMPANION_HEARTBEAT_ENABLED',

    'SAVE_PREVIOUS_NAVIGATION',

    'ELECTRON_ARGS',

    'PHONE_ENABLED',
    'PHONE_NEW_UA',
    'PHONE_NEW_SESSION',
    'PHONE_REMOVE_SESSION',
    'PHONE_SESSION_ACCEPTED',
    'PHONE_AUDIO_REFERENCE',
    'PHONE_RINGTONE_REFERENCE',
    'PHONE_NEW_DTMF_SENDER',
    'PHONE_MUTED',
    'PHONE_MUTE_PENDING',
    'PHONE_MUTE_PENDING_CLEARED',
    'PHONE_ISONHOLD',
    'EXTENSION_ATTENDED_TRANSFER_PENDING',
    'EXTENSION_ATTENDED_TRANSFER_RESOLVED',
    'PHONE_CONNECTED',
    'PHONE_REGISTERED',
    'PHONE_PLAY_RINGTONE_SETTING',
    'REGISTER_HEADSET_REF',
    'UNREGISTER_HEADSET_REF',
    'ENABLE_HEADSETS',
    'DISABLE_HEADSETS',
    'ENABLE_HEADSETS_AFTER_MULTIPLE_CALLS',
    'DISABLE_HEADSETS_WHEN_MULTIPLE_CALLS',
    'DEVICES_PREFERRED_MICROPHONE_ID',
    'DEVICES_PREFERRED_AUDIO_OUTPUT_ID',
    'DEVICES_PREFERRED_RINGTONE_AUDIO_OUTPUT_ID',
    'DEVICES_PREFERRED_VIDEO_INPUT_ID',
    'DEVICES_NOISE_SUPPRESSION_ENGINE',
    'CONNECTED_MEDIA_DEVICES',
    'SET_CALL_WAITING',
    'SET_OMNICHANNEL_DEEPLINK_ID',
    'SET_OPEN_TICKETS_ASSIGNED_USER_DATA',
    'SET_OPEN_TICKETS_UNASSIGNED_DATA',
    'SET_TICKET_EVENT_MESSAGE_STATUS',
    'SET_TICKET_EVENT_ATTACHMENTS',
    'SET_TICKETS_PERMISSION_EDIT_TICKETS',
    'SET_TICKETS_ALL_DATA',
    'SET_TICKETS_SEARCHED_DATA',
    'SET_TICKET_DATA',
    'SET_TICKET_EVENTS',
    'ADD_TICKET_EVENT',
    'SET_TICKET_ATTACHMENT_SEND_RESTRICTIONS',
    'SET_TICKET_AWAITING_ACTIVITY',
    'SET_TICKET_LAST_UPDATED',
    'SET_TICKET_REPLY_DRAFT',
    'SET_TICKET_SUBJECT',
    'SET_TICKET_VISIBILITY',
    'SET_TICKET_EVENT',
    'UPLOAD_FILE_STAGE_IN_SEND_TICKET_MESSAGE_FINISHED',
    'UPDATE_TICKET',
    'UPDATE_TICKET_TEMP_SEARCH_DATA',
    'SET_TICKETS_SETTINGS_FOR_QUEUE',
    'SET_DEFAULT_TICKET_VISIBILITY_FOR_QUEUE',
    'SET_CLOSED_TICKETS_DATA',
    'SET_TICKET_MEMBERS',
    'REMOVE_TICKET_MEMBER',
    'SET_TICKET_ASSIGNEE',
    'SET_TICKET_STATE',
    'SET_TICKET_EVENT_SUMMARY',
    'SET_TICKET_OPEN_AI_EXPERIMENTAL_TAGS',
    'REMOVE_TICKET_OPEN_AI_EXPERIMENTAL_TAG',
    'SET_TAGS_TO_TICKET',
    'ATTACH_TAG_TO_TICKET',
    'SET_ALL_TAGS_AVAILABLE_FOR_TICKET_TAGGING',
    'SET_NEW_TAG_CREATED',
    'SET_RENAME_TAG',
    'REMOVE_TAG_FROM_TICKET',
    'DELETE_TAGS_COMPLETELY',
    'APPLY_TICKET_MEMBERS_CHANGE',
    'REMOVE_TICKET',
    'REMOVE_TICKET_EVENT',
    'SET_TICKETS_BADGE_COUNT',
    'SET_TICKETS_OPEN_ASSIGNED_USER_COUNT_TOTAL',
    'INCREMENT_TICKETS_OPEN_ASSIGNED_USER_COUNT_TOTAL',
    'DECREMENT_TICKETS_OPEN_ASSIGNED_USER_COUNT_TOTAL',
    'SET_TICKETS_LIST_MOUNT_STATUS',
    'SET_TICKET_VIEW_MOUNT_STATUS',
    'SET_TICKET_EVENTS_MOUNT_STATUS',
    'CLEAR_TICKETS_DATA',
    'SET_TICKETS_TAB_ENFORCED',
    'SET_EMAIL_SIGNATURES_ENABLED',
    'SET_TICKETS_RELATED_DATA',
    'SET_TOTAL_RELATED_TICKETS_COUNT',
    'SET_BAG_VARIABLE_TICKET_ID_ACTIVE_CALL',

    'SET_SUPERVISOR_SELECTED_QUEUE',
    'SET_SUPERVISOR_SELECTED_OPERATOR',

    'RESULT_USER_CREDENTIALS',
    'SET_USER_CREDENTIALS_SUCCESS',
    'SET_USER_CREDENTIAL_FAILURE',

    'RESULT_RINGTONE_SETTINGS',
    'RESULT_RINGTONES_LIST',
    'SET_RINGTONE',

    'RESULT_USER_CAPABILITIES',
    'RESULT_EXTENSION_CAPABILITIES',
    'RESULT_EXTENSIONS_CAPABILITIES',
    'IS_ROAMING',

    'RESULT_RETAILER_LOGO',

    'PLAY_SOUND',
    'MIC_PERMISSION',
    'GEO_LOCATION',
    'GEO_RESTRICTION_ENABLED',
    'GEO_OUTSIDE_FENCE',

    'RESULT_NEW_PENDING_ESIM',

    // CTI SPECIFIC ACTIONS
    'CTI_USER_LOGGED_IN',
    'CTI_USER_LOGGED_OUT',
    'CTI_RESULT_CONTACT_DECORATIONS',
    'CTI_REGISTER_ORIGIN',
    'CTI_AUTH_REQUIRED',
    'CTI_REGISTER_TOKEN',
    'CTI_ACCESS_TOKEN_RESULT',
    'CTI_FEATURE_FLAGS',
    'CTI_CALL_LOG_SENT',
    'CTI_CLEAR_CALL_LOG_SENT',
    'CTI_SET_ONGOING_CALL',
    'CTI_SET_TOO_MANY_INSTANCES',
    'CTI_SET_SELECTED_CONTACT',

    'RESULT_GET_CALL_WIDGETS',
    'RESULT_UPDATE_CALL_WIDGET',
    'RESULT_DELETE_CALL_WIDGET',
    'UPDATE_CALL_WIDGET_TRIGGER_TYPE',

    'MEETING_CLEAR_STATE',
    'MEETING_SET_ACTIVE_MEETING_MEETING_CODE',
    'MEETING_SET_JOIN_EXPECTED_TO_BE_HELD',
    'MEETING_SET_LOBBY_MEETING_CODE',
    'MEETING_SET_LOBBY_CHAT_SESSION_ID',
    'MEETING_SET_LOBBY_PIN',
    'MEETING_SET_LOBBY_NUMBER',
    'MEETING_SET_SENDER_NAME',
    'MEETING_ADD_LOBBY_MEMBERS',
    'MEETING_SET_LOBBY_VIDEO_STREAM',
    'MEETING_SET_LOBBY_AUDIO_STREAM',
    'MEETING_SET_LOBBY_AUDIO_ACTIVE',
    'MEETING_SET_LOBBY_VIDEO_ACTIVE',
    'MEETING_SET_LOBBY_MIC_DEVICE_IN_USE',
    'MEETING_SET_LOBBY_VIDEO_DEVICE_IN_USE',
    'MEETING_SET_LOBBY_AUDIO_DEVICE_IN_USE',
    'MEETING_SET_LOBBY_CAMERA_ERROR',
    'MEETING_SET_LOBBY_ROOM_NOT_JOINED',
    'MEETING_SET_LOBBY_MEETING_ACCESS',
    'MEETING_SET_LOBBY_REQUIRE_HOST_PRESENT',
    'MEETING_SET_LOBBY_HOST_PRESENT',
    'MEETING_SET_LOBBY_MEETING_JOIN_BLOCKED_REASON',
    'MEETING_SET_LOBBY_VIEWER_IS_MEETING_HOST',
    'MEETING_SET_ACTIVE_MEETING_CALL_ID',
    'MEETING_SET_ACTIVE_MEETING_AUDIO_REFERENCE',
    'MEETING_SET_ACTIVE_MEETING_CALL_SESSION',
    'MEETING_SET_ACTIVE_MEETING_CALL_CONNECTION_STATE',
    'MEETING_SET_ACTIVE_MEETING_VIEW',
    'MEETING_SET_SENDER_AUDIO_ACTIVE_STATUS',
    'MEETING_SET_SENDER_AUDIO_STREAM',
    'MEETING_SET_ACTIVE_MEETING_CALL_USER_AGENT',
    'MEETING_SET_ACTIVE_MEETING_PIN',
    'MEETING_SET_ACTIVE_MEETING_MEMBERS',
    'MEETING_SET_ACTIVE_MEETING_NUMBER',
    'MEETING_SET_ACTIVE_MEETING_CHAT_SESSION_ID',
    'MEETING_SET_ACTIVE_MEETING_VIEWER_IS_MEETING_ADMIN',
    'MEETING_SET_ACTIVE_MEETING_MEETING_ACCESS',
    'MEETING_SET_ACTIVE_MEETING_CHAT_HISTORY_ACTIVATED',
    'MEETING_SET_ACTIVE_MEETING_MEETING_TYPE',
    'MEETING_SET_ACTIVE_MEETING_IS_ON_HOLD',
    'MEETING_SET_ACTIVE_MEETING_POLLING_INTERVAL',
    'MEETING_SET_ACTIVE_MEETING_IS_HOVERING',
    'MEETING_SET_ACTIVE_MEETING_IS_NARROW_WINDOW',
    'MEETING_SET_ACTIVE_MEETING_MEMBER_LIST_ACTIVE',
    'MEETING_SET_ACTIVE_MEETING_JOIN_INFO_ACTIVE',
    'MEETING_SET_ACTIVE_MEETING_HOST_CONTROLS_ACTIVE',
    'MEETING_SET_ACTIVE_MEETING_MONITOR_INTERVAL',
    'MEETING_SET_ACTIVE_MEETING_RECONNECT_ATTEMPT',
    'MEETING_SET_ACTIVE_MEETING_RECONNECT_ACTIVE',
    'MEETING_SET_ACTIVE_SCREEN_SHARER',
    'MEETING_SET_CHAT_OPEN_STATUS',
    'MEETING_SET_MIC_ALLOWED',
    'MEETING_SET_VIDEO_ALLOWED',
    'MEETING_SET_MIC_DEVICE_IN_USE',
    'MEETING_SET_AUDIO_DEVICE_IN_USE',
    'MEETING_SET_VIDEO_DEVICE_IN_USE',
    'MEETING_SET_AUDIO_DEVICE_LIST',
    'MEETING_SET_MIC_DEVICE_LIST',
    'MEETING_SET_VIDEO_DEVICE_LIST',
    'MEETING_SET_ERROR',
    'MEETING_SET_NUMBER_OF_MISSED_LOGS',
    'MEETING_SET_NETWORK_ERROR_LOGS',
    'MEETING_SET_MEETING_MEMBER_COUNT',
    'MEETING_CLEAR_MEMBER_COUNTS',
    'MEETING_SET_MEETING_NUMBERS',
    'MEETING_SET_CALLING_PARTICIPANTS',
    'MEETING_SET_VIDEO_CONFERENCE_CONFIG',

    'VIDEO_SET_WEBSOCKET',
    'VIDEO_SET_JOIN_ROOM_PROMISE',
    'VIDEO_SET_VIDEO_SENDER_STREAM',
    'VIDEO_SET_VIDEO_SECONDARY_SENDER_STREAM',
    'VIDEO_SET_VIDEO_SENDER_PRIMARY_PEER',
    'VIDEO_SET_VIDEO_SENDER_SECONDARY_PEER',
    'VIDEO_SET_SENDER_VIDEO_ACTIVE_STATUS',
    'VIDEO_SET_SENDER_SCREEN_SHARE_ACTIVE',
    'VIDEO_SET_SENDER_SCREEN_STREAM',
    'VIDEO_SET_SCREEN_SHARE_ASPECT',
    'VIDEO_ADD_VIDEO_MEMBER',
    'VIDEO_SET_SHOW_LOCAL_VIDEO_IN_GRID',
    'VIDEO_SET_SHOW_SCREEN_SHARE_IN_GRID',
    'VIDEO_SET_SHOW_INCOMING_VIDEO',
    'VIDEO_PIN_FEED',
    'VIDEO_UNPIN_FEED',
    'VIDEO_CLEAR_PINNED_FEEDS',
    'VIDEO_SET_VIDEO_MEMBER_SETUP_ATTEMPTS',
    'VIDEO_REMOVE_VIDEO_MEMBER',
    'VIDEO_CLEAR_VIDEO_MEMBERS',
    'VIDEO_SET_MEMBER_PRIMARY_PEER',
    'VIDEO_SET_MEMBER_SECONDARY_PEER',
    'VIDEO_SET_MEMBER_TRACK_ACTIVE_STATUS',
    'VIDEO_SET_NEW_ACTIVITY',
    'VIDEO_SET_SPEAKING_MEMBERS',
    'VIDEO_SET_OWN_USER_IS_SPEAKING',
    'VIDEO_SET_WAITING_PARTICIPANTS',
    'VIDEO_SET_OWN_WAITING_ROOM_STANDING',
    'VIDEO_SET_CONNECTION_STATE',
    'VIDEO_SET_SENDER_RECONNECTION_TOKEN',
    'VIDEO_SET_BACKGROUND_BLUR_AMOUNT',
    'VIDEO_SET_BACKGROUND_IMAGE',
    'VIDEO_SET_BACKGROUND_MODE',

    // MESSAGE LOADING ACTION
    'PUBLIC_MESSAGE_LOADING',

    //FEATURE FLAG ACTIONS
    'GET_SET_WEB_CLIENT_FEATURE_FLAGS',

    // Video chat (in-meeting side-channel; see flow/reducers/video-chat-reducer.ts)
    'VIDEO_CHAT_CONNECTED',
    'VIDEO_CHAT_RECONNECTING',
    'VIDEO_CHAT_DISCONNECTED',
    'VIDEO_CHAT_MESSAGE_RECEIVED',
    'VIDEO_CHAT_ERROR_RECEIVED',
    'VIDEO_CHAT_ERROR_CLEARED',
    'VIDEO_CHAT_EXTERNAL_MESSAGES_VIEWING',

    // Video 2.0
    'VIDEO2_INCOMING_CALL',
    'VIDEO2_OUTGOING_CALL',
    'VIDEO2_CLEAR_CALL_STATE',
    'VIDEO2_CALL_DECLINED',
    'VIDEO2_CALL_ACCEPTED',
    'VIDEO2_CALL_CANCELED',
    'VIDEO2_CALL_HANDLED',

    // Thread Messages
    'OPEN_SELECTED_THREAD_MESSAGE',
    'CLEAR_SELECTED_THREAD_MESSAGE',
    'RECEIVE_THREAD_MESSAGES',
    'RECEIVE_THREAD_MESSAGE',
    'RESULT_CHAT_THREAD_MESSAGE_READ',

    'ATTACHMENT_IMAGE_LOADED',

    'RESULT_KEYBOARD_SHORTCUTS',

    // Call Recording Transcription Progress
    'RESULT_CALL_RECORDING_TRANSCRIPTION_PROGRESS',

    'SET_EXTENDED_TRANSCRIPTION_INFO',

    'RESULT_DELETE_PERSONAL_RECORDED_CALL',
    'RESULT_DELETE_TRANSCRIPTION',
    'AUTO_LOGIN_WITH_ACCESS_TOKEN',
]);
